<div class="container mt-header">
    <div class="row">
        <div class="col-12 mt-5 text-center text-md-start">
            <p class="descripcion-polizas">
                Garantizamos la intervención de nuestros abogados en los siguientes eventos.
            </p>
            <p class="descripcion-polizas">
                En todas nuestras coberturas incluyen la elaboración del contrato de arrendamiento <br>
                y 2 consultas de incidencias legales, sin costo adicional: 
            </p>
        </div>
        
    </div>
</div>

<div class="container mt-5">
    <div class="row">

        <!-- 
            ESCRITORIO
         -->
        <div class="col-md-3 d-none d-lg-block" *ngFor="let p of poliza;let i = index">
            <mat-card class="card-polizas shadow-lg">
                <mat-card-header class="justify-content-center" [ngClass]="p.class">
                    <div class="title-card">
                        <img [src]="p.icono" [alt]="p.tipo">
                        <mat-card-title>{{p.tipo}}</mat-card-title>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <p class="title-card-poliza" *ngIf="i<=2">{{p.extrajudicial}}</p>
                    <ng-container *ngIf="i<=2">
                        <div class="lista" *ngFor="let e of p.listExtrajudicial">
                            <div class="lista-col-1">
                                {{e}}
                            </div>
                            <div class="lista-col-2">
                                <img src="assets/img/polizasJuridicas/IconoPverde.svg" alt="check">
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="i>2">
                        <div style="min-height: 617px;">
                            <div class="lista" *ngFor="let e of p.listAdicional">
                                <div class="lista-col-1">
                                    {{e}}
                                </div>
                                <div class="lista-col-2">
                                    <img src="assets/img/polizasJuridicas/IconoPverde.svg" alt="check">
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <mat-divider *ngIf="i<=2"></mat-divider>

                    <p class="title-card-poliza mt-5" *ngIf="i<=2">{{p.judicial}}</p>
                    <p class="descripcion-judicial" *ngIf="i<=2">
                        {{p.descripcionJudicial}} 
                    </p>
                    <ng-container *ngIf="i<=2">
                        <div style="min-height: 198px;">
                            <div class="lista" *ngFor="let j of p.listJudicial">
                                <div class="lista-col-1">
                                    {{j}}
                                </div>
                                <div class="lista-col-2">
                                    <img src="assets/img/polizasJuridicas/IconoPverde.svg" alt="check">
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </mat-card-content>
                <mat-card-actions *ngIf="i<=2">
                    <button mat-raised-button type="button" class="btn w-100" (click)="selecionaCobertura(i)" data-bs-toggle="modal" data-bs-target="#modalCotizador">{{p.boton}}</button>
                </mat-card-actions>
            </mat-card>
        </div>

        <!-- 
            MOBILE
         -->
        <div id="carouselCoberturasPolizasJuridicas" class="carousel slide col-12 d-block d-lg-none" data-bs-ride="carousel">
            <div class="carousel-indicators">
              <button type="button" data-bs-target="#carouselCoberturasPolizasJuridicas" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#carouselCoberturasPolizasJuridicas" data-bs-slide-to="1" aria-current="true" aria-label="Slide 2"></button>
              <button type="button" data-bs-target="#carouselCoberturasPolizasJuridicas" data-bs-slide-to="2" aria-current="true" aria-label="Slide 3"></button>
            </div>
            <div class="carousel-inner">
                <ng-container *ngFor="let p of poliza;let i = index">
                    <div class="carousel-item pb-5"
                     [ngClass]="{'active':i==0}" 
                     *ngIf="i<=2" 
                     data-bs-interval="20000"
                     (swipeleft)="sliderCarusel('left','carouselCoberturasPolizasJuridicas')" 
                     (swiperight)="sliderCarusel('right','carouselCoberturasPolizasJuridicas')">
                        <mat-card class="card-polizas shadow">
                            <mat-card-header class="justify-content-center" [ngClass]="p.class">
                                <div class="title-card">
                                    <img [src]="p.icono" [alt]="p.tipo">
                                    <mat-card-title>{{p.tipo}}</mat-card-title>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <p class="title-card-poliza">{{p.extrajudicial}}</p>
                                <ng-container>
                                    <div class="lista" *ngFor="let e of p.listExtrajudicial">
                                        <div class="lista-col-1">
                                            {{e}}
                                        </div>
                                        <div class="lista-col-2">
                                            <img src="assets/img/polizasJuridicas/IconoPverde.svg" alt="check">
                                        </div>
                                    </div>
                                </ng-container>
            
                                <mat-divider></mat-divider>
            
                                <p class="title-card-poliza mt-5">{{p.judicial}}</p>
                                <p class="descripcion-judicial">
                                    {{p.descripcionJudicial}} 
                                </p>
                                <ng-container>
                                    <div style="min-height: 198px;">
                                        <div class="lista" *ngFor="let j of p.listJudicial">
                                            <div class="lista-col-1">
                                                {{j}}
                                            </div>
                                            <div class="lista-col-2">
                                                <img src="assets/img/polizasJuridicas/IconoPverde.svg" alt="check">
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </mat-card-content>
                            <mat-card-actions>
                                <button mat-raised-button type="button" class="w-100" (click)="selecionaCobertura(i)" data-bs-toggle="modal" data-bs-target="#modalCotizador">{{p.boton}}</button>
                            </mat-card-actions>
                        </mat-card>
                    </div>
                </ng-container>
            </div>
        </div>
        <mat-card class="card-polizas shadow col-12 mt-4 d-lg-none d-block" >
            <mat-card-header class="justify-content-center" [ngClass]="poliza[3].class">
                <div class="title-card">
                    <img [src]="poliza[3].icono" [alt]="poliza[3].tipo">
                    <mat-card-title>{{poliza[3].tipo}}</mat-card-title>
                </div>
            </mat-card-header>
            <mat-card-content>
                <div>
                    <div class="lista" *ngFor="let e of poliza[3].listAdicional">
                        <div class="lista-col-1">
                            {{e}}
                        </div>
                        <div class="lista-col-2">
                            <img src="assets/img/polizasJuridicas/IconoPverde.svg" alt="check">
                        </div>
                    </div>
                </div>

            </mat-card-content>
        </mat-card>

    </div>
</div>

<div class="container-fluid mt-3">
    <div class="row">
        <div class="col-12">
            <h3 class="title">Contacto</h3>
        </div>
    </div>
</div>

<div class="container-fluid container-contacto pt-md-5 pb-md-4 mb-md-5">
    <div class="row">
        <div class="contacto col-12">
            <div class="row justify-content-center d-none d-md-flex">
                <div class="col-md-4 col-lg-3 text-center" *ngFor="let c of contacto">
                    <div class="card">
                        <img [src]="c.img"  [alt]="c.nombreOficina">
                        <div class="card-body">
                          <h5 class="card-title">{{c.nombreOficina}}</h5>
                          <p class="tel">Teléfono</p>
                          <p class="num-tel">{{c.telefono}}</p>
                        </div>
                    </div>
                    <button [routerLink]="['/','contacto']" class="card-btn" mat-raised-button>{{c.boton}}</button>
                </div>
            </div>
            <!--
                responsivo
            -->
            <div id="carouselContactoPolizasJuridicas" class="carousel slide mt-3 pb-3 mb-3 d-block d-md-none" data-bs-ride="carousel">
                <div class="carousel-indicators">
                  <button type="button" data-bs-target="#carouselContactoPolizasJuridicas" [attr.data-bs-slide-to]="j" [ngClass]="{'active': j == 0}" *ngFor="let c of contacto;let j = index" aria-current="true" aria-label="Slide {{j+1}}"></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item"
                     [ngClass]="{'active':i==0}" 
                     data-bs-interval="20000" *ngFor="let c of contacto;let i = index"
                     (swipeleft)="sliderCarusel('left','carouselContactoPolizasJuridicas')" 
                     (swiperight)="sliderCarusel('right','carouselContactoPolizasJuridicas')">
                        <div class="col-12 text-center">
                            <div class="card">
                                <img [src]="c.img"  [alt]="c.nombreOficina">
                                <div class="card-body">
                                  <h5 class="card-title">{{c.nombreOficina}}</h5>
                                  <p class="tel">Teléfono</p>
                                  <p class="num-tel">{{c.telefono}}</p>
                                </div>
                            </div>
                            <button [routerLink]="['/','contacto']" class="card-btn" mat-raised-button>{{c.boton}}</button>
                        </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalCotizador" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <img class="background" src="assets/img/polizasJuridicas/cotizador.png" alt="cotizador">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Cotizador</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" data-bs-target="#modalCotizador" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <mat-label class="ciudad">Ciudad de México y Área Metropolitana</mat-label> <br><br>
                <form [formGroup]="cotizadorForm" (ngSubmit)="cotiza()">
                    <mat-form-field class="col-12" appearance="fill">
                        <mat-label>*Importe de renta</mat-label>
                        <input id="importeRenta" matInput placeholder="1,043" (blur)="aparecePrefijo(false)" (focus)="aparecePrefijo(true)" formControlName="importeRenta" #importeRenta>
                        <span *ngIf="prefixInput" matPrefix>$&nbsp;</span>
                        <span *ngIf="prefixInput" matSuffix>.00</span>
                        <mat-error *ngIf="cotizadorForm.controls['importeRenta'].errors?.required && cotizadorForm.controls['importeRenta'].touched">
                            Este campo es requerido
                        </mat-error>
                        <mat-error *ngIf="cotizadorForm.controls['importeRenta'].errors?.pattern && cotizadorForm.controls['importeRenta'].touched">
                            Solo se permiten números
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="col-12">
                        <mat-label>Cobertura</mat-label>
                        <mat-select formControlName="cobertura" #cobertura>
                            <mat-option value="bronce">Bronce</mat-option>
                            <mat-option value="oro">Oro</mat-option>
                            <mat-option value="platino">Platino</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-label *ngIf="costoPoliza != 0" class="costoPoliza">El costo de la poliza es de: {{ costoPoliza | currency }} </mat-label>
                    <mat-spinner *ngIf="procesando" [diameter]="30"></mat-spinner>
                    <div class="modal-footer">
                        <button class="col-12" [disabled]="procesando" mat-raised-button>Cotizar</button>
                        <mat-label>* Incluir IVA en el importe de la renta.</mat-label>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
